import styled from "styled-components";

const Wrapper = styled.div``;

const NamePrimary = styled.div`
  font-weight: 700;
`;

const NameSecondary = styled.div`
  font-weight: 400;
  font-size: 1em;
  letter-spacing: 0.1em;
`;

const NameTertiary = styled.div`
  font-weight: 400;
  font-size: 0.8em;
  letter-spacing: 0.1em;
`;

export type NameFormatted = {
  primary: string;
  secondary?: string;
  tertiary?: string;
};

const StructuredHeading = (props: {
  nameFormatted?: NameFormatted;
  name?: string;
  versionTitle?: React.ReactNode;
}) => {
  const { nameFormatted, name, versionTitle } = props;

  return (
    <Wrapper>
      {nameFormatted ? (
        <>
          <NamePrimary>{nameFormatted.primary}</NamePrimary>
          {nameFormatted.secondary && (
            <NameSecondary>{nameFormatted.secondary}</NameSecondary>
          )}
          {nameFormatted.tertiary && (
            <NameTertiary>{nameFormatted.tertiary}</NameTertiary>
          )}
        </>
      ) : (
        <NamePrimary>{name}</NamePrimary>
      )}
      {versionTitle}
    </Wrapper>
  );
};

export default StructuredHeading;
